import { render, staticRenderFns } from "./formulario_campo_builder.vue?vue&type=template&id=ae2eddac&scoped=true"
import script from "./formulario_campo_builder.vue?vue&type=script&lang=js"
export * from "./formulario_campo_builder.vue?vue&type=script&lang=js"
import style0 from "./formulario_campo_builder.vue?vue&type=style&index=0&id=ae2eddac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae2eddac",
  null
  
)

export default component.exports